import React, { useEffect } from "react";
import { getSession, valdiatePage } from "../../global";
import { useHistory } from 'react-router-dom';
import Form from "./form";

const ShipperAdvice = () => {
    const history = useHistory();
    useEffect(() => {
        if (!valdiatePage('/shipperadvice')) {
            history.push('/login');
        }
        return () => {
        }
    }, []);


    return getSession('userInfo') && <section className="section">
        {/* <div className="section-header">
            <h1>Shipper Advice</h1>
        </div> */}
        <div className="card" style={{ padding: 10 }}>
            <Form />
        </div>
    </section>
}

export default ShipperAdvice;